import { useState } from 'react';
import toast from 'react-hot-toast';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/Button';

type Props = {
  conversationId: string;
  onSent: () => Promise<void> | void;
  /** Esconde ações financeiras se não for CLIENTE */
  isCliente?: boolean;
};

const ACTIONS: Array<{
  id: string;
  label: string;
  clienteOnly?: boolean;
  documentoTipo?: string;
  confirm?: string;
}> = [
  {
    id: 'boletos_abertos',
    label: 'Boletos',
    clienteOnly: true,
    confirm: 'Enviar lista de boletos em aberto para o cliente?',
  },
  { id: 'resumo_financeiro', label: 'Resumo', clienteOnly: true },
  { id: 'orientar_os', label: 'Agendar O.S.', clienteOnly: true },
  { id: 'pedir_documento', label: 'Pedir doc', documentoTipo: 'outro' },
  { id: 'handoff_assumido', label: 'Assumimos' },
  { id: 'aguarde_analise', label: 'Aguarde' },
];

export function AtendimentoQuickActions({ conversationId, onSent, isCliente = true }: Props) {
  const [busy, setBusy] = useState<string | null>(null);

  const run = async (action: (typeof ACTIONS)[number]) => {
    if (action.confirm && !window.confirm(action.confirm)) return;
    setBusy(action.id);
    try {
      await api.post(`/rique-atendimento/portal/conversations/${conversationId}/quick-actions`, {
        action: action.id,
        ...(action.documentoTipo ? { documentoTipo: action.documentoTipo } : {}),
      });
      toast.success('Mensagem enviada');
      await onSent();
    } catch (e: any) {
      toast.error(e?.response?.data?.message || 'Falha na ação rápida');
    } finally {
      setBusy(null);
    }
  };

  const visible = ACTIONS.filter((a) => !a.clienteOnly || isCliente);

  return (
    <div className="flex flex-wrap gap-1.5 px-2 pt-2">
      <span className="text-[10px] uppercase tracking-wide text-muted-foreground self-center mr-1">
        Ações
      </span>
      {visible.map((a) => (
        <Button
          key={a.id}
          type="button"
          size="sm"
          variant="outline"
          className="h-7 text-xs px-2"
          disabled={Boolean(busy)}
          onClick={() => void run(a)}
        >
          {busy === a.id ? '…' : a.label}
        </Button>
      ))}
    </div>
  );
}
